import { render } from "./ContractRegistrationEdit.vue?vue&type=template&id=2c4bec36"
import script from "./ContractRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./ContractRegistrationEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__